export const CREATE_YOUR_PLAN_TEXT = 'Create Your Plan'
export const HEADER_TEXT = 'Prepare Snapshot'
export const LAUNCH_THE_PROGRAM_TEXT = 'Launch the Program'
export const NEXT_BUTTON_TEXT = 'Next'
export const NO_CLASSES_TEXT = 'No Classes Yet'
export const ORDER_BY = {
  ASC: 'asc',
  DESC: 'desc',
}
export const PREVIOUS_BUTTON_TEXT = 'Previous'
export const SITES_HEADER_TEXT = 'Schools'
export const SORT_KEYS = {
  [CREATE_YOUR_PLAN_TEXT]: 'planProgressNumber',
  [LAUNCH_THE_PROGRAM_TEXT]: 'launchProgressNumber',
  [SITES_HEADER_TEXT]: 'name',
}
